import { createFileRoute, redirect } from '@tanstack/react-router'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { SEARCH_PARAM_POINT_CLOUD_OR_SCENE_ID } from 'routes/point-cloud/-searchParams'
import { Route as NewIndexRoute } from 'routes/point-cloud/index'
import { Route as NewViewRoute } from 'routes/point-cloud/view'

export const Route = createFileRoute(
  '/point-cloud/(deprecated_routes)/$siteID/{-$pointCloudOrSceneID}'
)({
  beforeLoad: ({ params }) => {
    const pointCloudOrSceneID = params.pointCloudOrSceneID
    if (pointCloudOrSceneID) {
      throw redirect({
        to: NewViewRoute.to,
        search: (prev) => ({
          ...prev,
          [SEARCH_PARAM_SITE_ID]: params.siteID,
          [SEARCH_PARAM_POINT_CLOUD_OR_SCENE_ID]: pointCloudOrSceneID,
        }),
        replace: true,
      })
    }

    throw redirect({
      to: NewIndexRoute.to,
      search: (prev) => ({
        ...prev,
        [SEARCH_PARAM_SITE_ID]: params.siteID,
      }),
      replace: true,
    })
  },
})
